import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_VISITS_REQUEST, fetchVisitsSuccess, fetchVisitsFailure,
  CREATE_VISIT_REQUEST, createVisitSuccess, createVisitFailure,
  UPDATE_VISIT_REQUEST, updateVisitSuccess, updateVisitFailure,
  DELETE_VISIT_REQUEST, deleteVisitSuccess, deleteVisitFailure
} from '../actions/visitActions';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = getBaseUrl();
const authToken = localStorage.getItem('authToken');
const getAuthToken = () => localStorage.getItem('authToken');

const createConfig = () => ({
  headers: { 'Authorization': `Bearer ${authToken}` }
});

function* fetchVisits(action) {
  try {
    const token = getAuthToken();
    const { projectId, page , limit , search = '', group = '' } = action.payload || {};
    
    console.log("Fetching dep with payload: ", action.payload);

    const response = yield call(
      axios.get,
      `${getBaseUrl()}/${projectId}/visit`, // Updated endpoint
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search, group },
      }
    );

    // Expecting `data` and `meta` in the response
    yield put(fetchVisitsSuccess(response.data));
  } catch (error) {
    console.error("Error fetching visit: ", error);
    yield put(fetchVisitsFailure(error.response?.data?.message || error.message));
  }
}

function* createVisit(action) {
  try {
    const projectId=action.payload.data.projectId
   delete action.payload.data.projectId
    const response = yield call(axios.post, `${API_BASE_URL}/${projectId}/visit`, action.payload.data, createConfig());
    yield put(createVisitSuccess(response.data));
  } catch (error) {
    yield put(createVisitFailure(error.message));
  }
}

function* updateVisit(action) {
  try {
    const { id, data , projectId} = action.payload;
    const response = yield call(axios.put, `${API_BASE_URL}/${projectId}/visit/${id}`, data, createConfig());
    yield put(updateVisitSuccess(response.data));
  } catch (error) {
    yield put(updateVisitFailure(error.message));
  }
}

function* deleteVisit(action) {
  try {
    const { id,projectId } = action.payload;
    yield call(axios.delete, `${API_BASE_URL}/${id}/visit/${projectId}`, createConfig());
    yield put(deleteVisitSuccess(id));
  } catch (error) {
    yield put(deleteVisitFailure(error.message));
  }
}

export default function* visitSaga() {
  yield takeLatest(FETCH_VISITS_REQUEST, fetchVisits);
  yield takeLatest(CREATE_VISIT_REQUEST, createVisit);
  yield takeLatest(UPDATE_VISIT_REQUEST, updateVisit);
  yield takeLatest(DELETE_VISIT_REQUEST, deleteVisit);
}
